import {useEffect} from "react";

const StepThreeForm = (props) => {

    const handleKeyPress = (e) => {
        // Bloque la saisie si la touche n'est pas un chiffre (0-9)
        if (!/^[0-9]$/.test(e.key)) {
            e.preventDefault();
        }
    };

    useEffect(() => {
        // Reposition de la vue au début du formulaire au changement d'étape
        document.getElementById("devis-sante-title").scrollIntoView({behavior: 'smooth'});
    }, [])

    return (

        <div className="tw-flex tw-flex-col tw-py-6 tw-gap-6 tw-self-stretch tw-flex-wrap">
            <div className="tw-flex tw-flex-col tw-items-start tw-content-start tw-gap-6 tw-self-stretch lg:tw-flex-wrap lg:tw-flex-row">
                <div className="tw-flex tw-flex-col tw-gap-2 tw-self-stretch lg:tw-w-[508px]">
                    <label htmlFor="inputCompanyName" className="tw-text-sm-h5 lg:tw-text-h5">Nom de la société
                        *</label>
                    <input {...props.register("inputCompanyName", {required: true})} id="inputCompanyName" type="text" maxLength="200"
                           className={`tw-flex tw-py-3 tw-px-2 tw-gap-2 tw-self-stretch tw-items-center tw-rounded tw-border-solid tw-border tw-border-mutelios-blue-border ${props.errors.inputCompanyName && ("tw-border-solid tw-border-2 tw-border-mutelios-danger")}`}/>
                </div>
                <div className="tw-flex tw-flex-col tw-gap-2 tw-self-stretch lg:tw-w-[508px]">
                    <label htmlFor="inputCompanySiret" className="tw-text-sm-h5 lg:tw-text-h5">N° SIRET</label>
                    <input {...props.register("inputCompanySiret")} id="inputCompanySiret" type="text" onKeyPress={handleKeyPress} maxLength="14"
                           className="tw-flex tw-py-3 tw-px-2 tw-gap-2 tw-self-stretch tw-items-center tw-rounded tw-border-solid tw-border tw-border-mutelios-blue-border"/>
                </div>
                <div className="tw-flex tw-flex-col tw-gap-2 tw-self-stretch lg:tw-w-[508px]">
                    <label htmlFor="inputCompanyAddress" className="tw-text-sm-h5 lg:tw-text-h5">Adresse du siège
                        *</label>
                    <input {...props.register("inputCompanyAddress", {required: true})} id="inputCompanyAddress" type="text" maxLength="200"
                           className={`tw-flex tw-py-3 tw-px-2 tw-gap-2 tw-self-stretch tw-items-center tw-rounded tw-border-solid tw-border tw-border-mutelios-blue-border ${props.errors.inputCompanyAddress && ("tw-border-solid tw-border-2 tw-border-mutelios-danger")}`}/>
                </div>
                <div className="tw-flex tw-flex-col tw-gap-2 tw-self-stretch lg:tw-w-[508px]">
                    <label htmlFor="inputEstimatePostalCode" className="tw-text-sm-h5 lg:tw-text-h5">Code postal du siège</label>
                    <input id="inputEstimatePostalCode" type="text" disabled value={props.postalCode}
                           className="tw-flex tw-py-3 tw-px-2 tw-gap-2 tw-self-stretch tw-items-center tw-rounded tw-border-solid tw-border tw-border-mutelios-blue-border"/>
                </div>
                <div className="tw-flex tw-flex-col tw-gap-2 tw-self-stretch lg:tw-w-[508px]">
                    <label htmlFor="inputEstimateCity" className="tw-text-sm-h5 lg:tw-text-h5">Ville du siège</label>
                    <input id="inputEstimateCity" type="text" disabled value={props.city}
                           className="tw-flex tw-py-3 tw-px-2 tw-gap-2 tw-self-stretch tw-items-center tw-rounded tw-border-solid tw-border tw-border-mutelios-blue-border"/>
                </div>
                <div className="tw-flex tw-flex-col tw-gap-2 tw-self-stretch lg:tw-w-[600px]">
                    <label className="tw-text-sm-h5 lg:tw-text-h5">Civilité *</label>
                    <div className="tw-self-stretch">
                        <div className={`tw-flex tw-items-start tw-gap-2 ${props.errors.inputCivility && ("tw-border-solid tw-border-2 tw-border-mutelios-danger")}`}>
                            <div className="tw-flex tw-items-center tw-gap-2">
                                <input {...props.register("inputCivility", {required: true})} value="MR" id="civilityM" type="radio"/>
                                <label htmlFor="civilityM">M</label>
                            </div>
                            <div className="tw-flex tw-items-center tw-gap-2">
                                <input {...props.register("inputCivility", {required: true})} value="MADAME" id="civilityF" type="radio"/>
                                <label htmlFor="civilityF">Mme</label>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="tw-flex tw-flex-col tw-gap-2 tw-self-stretch lg:tw-w-[508px]">
                    <label htmlFor="inputEstimateLastName" className="tw-text-sm-h5 lg:tw-text-h5">Nom interlocuteur
                        *</label>
                    <input {...props.register("inputEstimateLastName", {required: true})} id="inputEstimateLastName" type="text" maxLength="100"
                           className={`tw-flex tw-py-3 tw-px-2 tw-gap-2 tw-self-stretch tw-items-center tw-rounded tw-border-solid tw-border tw-border-mutelios-blue-border ${props.errors.inputEstimateLastName && ("tw-border-solid tw-border-2 tw-border-mutelios-danger")}`}/>
                </div>
                <div className="tw-flex tw-flex-col tw-gap-2 tw-self-stretch lg:tw-w-[508px]">
                    <label htmlFor="inputEstimateFirstname" className="tw-text-sm-h5 lg:tw-text-h5">Prénom
                        interlocuteur *</label>
                    <input {...props.register("inputEstimateFirstname", {required: true})} id="inputEstimateFirstname" type="text" maxLength="100"
                           className={`tw-flex tw-py-3 tw-px-2 tw-gap-2 tw-self-stretch tw-items-center tw-rounded tw-border-solid tw-border tw-border-mutelios-blue-border ${props.errors.inputEstimateFirstname && ("tw-border-solid tw-border-2 tw-border-mutelios-danger")}`}/>
                </div>
                <div className="tw-flex tw-flex-col tw-gap-2 tw-self-stretch lg:tw-w-[508px]">
                    <label htmlFor="inputEstimateProfession" className="tw-text-sm-h5 lg:tw-text-h5">Fonction
                        interlocuteur *</label>
                    <input {...props.register("inputEstimateProfession", {required: true})} id="inputEstimateProfession" type="text" maxLength="150"
                           className={`tw-flex tw-py-3 tw-px-2 tw-gap-2 tw-self-stretch tw-items-center tw-rounded tw-border-solid tw-border tw-border-mutelios-blue-border ${props.errors.inputEstimateProfession && ("tw-border-solid tw-border-2 tw-border-mutelios-danger")}`}/>
                </div>
                <div className="tw-flex tw-flex-col tw-gap-2 tw-self-stretch lg:tw-w-[508px]">
                    <label htmlFor="estimateEmail" className="tw-text-sm-h5 lg:tw-text-h5">Adresse mail
                        *</label>
                    <input {...props.register("inputEstimateEmail", {
                        required: true,
                        maxLength: 50,
                        pattern: "[a-z0-9._%+-]+@[a-z0-9.-]+.[a-z]{2,4}$"})} id="estimateEmail" type="email"
                           className={`tw-flex tw-py-3 tw-px-2 tw-gap-2 tw-self-stretch tw-items-center tw-rounded tw-border-solid tw-border tw-border-mutelios-blue-border ${props.errors.inputEstimateEmail && ("tw-border-solid tw-border-2 tw-border-mutelios-danger")}`}/>
                </div>
                <div className="tw-flex tw-flex-col tw-gap-2 tw-self-stretch lg:tw-w-[508px]">
                    <label htmlFor="inputEstimatePhoneNumber" className="tw-text-sm-h5 lg:tw-text-h5">Téléphone
                        direct *</label>
                    <input {...props.register("inputEstimatePhoneNumber", {
                        required: true, maxLength: 20,
                        pattern: {
                            value: /^$|0[0-9]{9}$/,
                            message: 'Le numéro de téléphone doit commencer par 0 et contenir 10 chiffres.',
                        }})} id="inputEstimatePhoneNumber" type="text"
                           className={`tw-flex tw-py-3 tw-px-2 tw-gap-2 tw-self-stretch tw-items-center tw-rounded tw-border-solid tw-border tw-border-mutelios-blue-border ${props.errors.inputEstimatePhoneNumber && ("tw-border-solid tw-border-2 tw-border-mutelios-danger")}`}/>
                    {props.errors.inputEstimatePhoneNumber && (
                        <p style={{ color: 'red' }}>{props.errors.inputEstimatePhoneNumber.message}</p>
                    )}
                </div>
            </div>
        </div>
    );
}

export default StepThreeForm;
